import useFeature from '~/client/hooks/feature/useFeature';

const useIsCloudFlareTurnstileEnabled = () =>
  useFeature('isCloudFlareTurnstileEnabled');

export default useIsCloudFlareTurnstileEnabled;
